module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/91f2e12fe429965b5b219f289cf6aa31.png";